import withTenants from 'components/with-tenants'
import withUsers from 'components/with-users'
import { pipe } from 'ramda'
import ConfigureOwnership from '../configure-ownership'

export default pipe(withUsers, withTenants)(ConfigureOwnership)



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-ownership/container/index.js